<script>
  import Button from './Button.svelte';
  import { nextInkSeed } from '../../lib/ink.js';

  let {
    open = false,
    title = 'Are you sure?',
    body = '',
    confirmLabel = 'Confirm',
    danger = true,
    onconfirm,
    oncancel,
  } = $props();

  let dialogEl = $state(null);

  $effect(() => {
    if (open) dialogEl?.focus();
  });

  function handleKeydown(e) {
    if (e.key === 'Escape') oncancel?.();
  }
</script>

{#if open}
  <div class="fixed inset-0 z-50 flex items-center justify-center px-4">
    <div class="absolute inset-0 bg-primary-950/50" onclick={() => oncancel?.()} aria-hidden="true"></div>
    <div
      bind:this={dialogEl}
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-body"
      tabindex="-1"
      onkeydown={handleKeydown}
      data-augmented-ui="tl-tear br-tear bl-deckle"
      data-ink-seed={nextInkSeed()}
      class="card-elevated !p-6 w-full max-w-sm focus:outline-none"
    >
      <h2 id="confirm-dialog-title" class="text-hierarchy-3 mb-2">{title}</h2>
      {#if body}
        <p id="confirm-dialog-body" class="text-sm text-secondary-600 mb-6">{body}</p>
      {/if}
      <div class="flex items-center justify-end gap-3">
        <Button variant="ghost" onclick={() => oncancel?.()}>Cancel</Button>
        <Button variant={danger ? 'danger' : 'primary'} onclick={() => onconfirm?.()}>{confirmLabel}</Button>
      </div>
    </div>
  </div>
{/if}
